import { render } from "./YourNeeds.vue?vue&type=template&id=44dcb9ef&scoped=true&ts=true"
import script from "./YourNeeds.vue?vue&type=script&lang=ts"
export * from "./YourNeeds.vue?vue&type=script&lang=ts"

import "./YourNeeds.vue?vue&type=style&index=0&id=44dcb9ef&scoped=true&lang=scss"

import exportComponent from "D:\\_dev\\engenious-pl\\public-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44dcb9ef"]])

export default __exports__